import React from 'react';
import { Button, Checkbox, Popconfirm } from 'antd';
import { Text4, DangerousLink } from '../../../styles';
import { PermissionHoc } from '../../HOC';
import { printRupee } from '../../../app_methods';

const UpdatePermissableButton = PermissionHoc(Button,"USERS_WRITE",{ is_component: true, fallbackComponent: null })
const PermissableButton = PermissionHoc(Button,"USERS_PERMISSIONS",{ is_component: true, fallbackComponent: null })
const PermissablePopConfirm = PermissionHoc(Popconfirm,"USERS_WRITE",{ is_component: true, fallbackComponent: null })

export const getUsersTableColumns = (methods, current_user) => [
{
    title: "Name",
    key: "name",
    render: (record) => <Text4>{record.name}{current_user.user.id?current_user.user.id==record.id?<span className="ml-1 p-1 badge badge-pill badge-dark">You</span>:"":""}</Text4>
}, {
    title: "Email ID",
    key: "email",
    render: (record) => <Text4>{record.email}</Text4>
}, {
    title: "Phone",
    key: "phone",
    render: (record) => <Text4>{record.phone}</Text4>
},
{
    title: "Level",
    key: "level",
    render: (record) => <Text4>{record.level}</Text4>
},
{
    title: "Balance",
    key: "balance_amount",
    render: (record) => <Text4>{record.enable_spending_limit ? printRupee(record.balance_amount):'---'}</Text4>
},
{
    title: "Actions",
    render: (record) => <>
        <UpdatePermissableButton className="mr-1" size="small" onClick={() => methods.toggleUserModal({ ...record, is_edit: true })}>Edit</UpdatePermissableButton>
        <UpdatePermissableButton className="mr-1" size="small" onClick={() => methods.toggleResendPasswordModal({ ...record })}>Resend Password</UpdatePermissableButton>
        {current_user.user.id?
            current_user.user.id==record.id?null:<PermissableButton className="mr-1" size="small" onClick={() => methods.togglePermissionModal({ ...record })}>Permissions</PermissableButton>
            :<PermissableButton className="mr-1" size="small" onClick={() => methods.togglePermissionModal({ ...record })}>Permissions</PermissableButton>}
        {current_user.user.id?
            current_user.user.id==record.id?null:
            record.is_active ?
                <PermissablePopConfirm
                    placement="bottomRight"
                    title="Are you sure you want to deactivate this user account?"
                    okText="Yes"
                    cancelText="No"
                    onConfirm={() => methods.updateStatus({ ...record }, false)}
                >
                    <DangerousLink size="small">Deactivate</DangerousLink>
                </PermissablePopConfirm>
                :
                <PermissablePopConfirm
                    placement="bottomRight"
                    title="Are you sure you want to activate this user account?"
                    okText="Yes"
                    cancelText="No"
                    onConfirm={() => methods.updateStatus({ ...record }, true)}
                >
                    <Button size="small">Activate</Button>
                </PermissablePopConfirm>
            :
                record.is_active ?
                <PermissablePopConfirm
                    placement="bottomRight"
                    title="Are you sure you want to deactivate this user account?"
                    okText="Yes"
                    cancelText="No"
                    onConfirm={() => methods.updateStatus({ ...record }, false)}
                >
                    <DangerousLink size="small">Deactivate</DangerousLink>
                </PermissablePopConfirm>
                :
                <PermissablePopConfirm
                    placement="bottomRight"
                    title="Are you sure you want to activate this user account?"
                    okText="Yes"
                    cancelText="No"
                    onConfirm={() => methods.updateStatus({ ...record }, true)}
                >
                    <Button size="small">Activate</Button>
                </PermissablePopConfirm>
        }
    </>
}];


export const usersFilterNodes = [{
    label: "Name",
    field: "name",
    placeholder: "Enter Name",
    inputType: "text",
    defaultValue: ""
}, {
    label: "Email ID",
    field: "email",
    placeholder: "Enter Email ID",
    inputType: "text",
    defaultValue: ""
}, {
    label: "Phone",
    field: "phone",
    placeholder: "Enter Phone",
    inputType: "text",
    defaultValue: ""
},
{
    label: "Level",
    field: "level",
    placeholder: "Select Level",
    inputType: "select",
    defaultValue: undefined,
    options: ['L1', 'L2', 'L3', 'L4', 'L5'].map(level => {
        let object = {};
        object.key = level;
        object.value = level;
        object.label = <Text4>{level}</Text4>;
        return object;
    })
    },
];